import React from 'react';
import { DEFAULT_USER_AVATAR, PAYMENT_INFO, TRANSACTION_TYPE } from '../../shared/constants/common';
import { formatAmountWithTwoDecimalPlaces } from '../../shared/utils/function';

const CheckoutSummaryCard = ({
  creatorInfo,
  paymentForm,
  purchaseAmount,
  showDetails,
  onToggleDetails,
  vatAmount = 0,
  vatPercentage = 0
}) => {
  // Utility to read a named field from paymentForm
  const getFormValue = (name) => paymentForm?.find((field) => field.name === name)?.value;

  // Determine payment amount (prefer prop, then initial/recurring from form, fallback)
  const paymentAmountRaw =
    purchaseAmount ??
    getFormValue('initialPrice') ??
    getFormValue('recurringPrice') ??
    '6.00';

  // Normalize to a number once
  const paymentAmount = Number(paymentAmountRaw);

  // Get payment type for display
  const paymentTypeRaw = getFormValue('c_payment_type');
  const paymentType =
    paymentTypeRaw === TRANSACTION_TYPE.TIP || paymentTypeRaw === TRANSACTION_TYPE.MESSAGES_TIP
      ? 'Tip'
      : paymentTypeRaw === TRANSACTION_TYPE.PURCHASE_CONTENT
        ? 'Purchase'
        : paymentTypeRaw === TRANSACTION_TYPE.MESSAGE_PURCHASE_CONTENT
        ? 'Message Purchase'
        : paymentTypeRaw === TRANSACTION_TYPE.WALLET_CREDIT_PURCHASE
          ? 'Call Credits'
          : 'Subscription';

  const isSubscription = paymentType === 'Subscription';
  const vatAsNumber = Number(vatAmount);
  const netAmount = (paymentAmount - vatAsNumber - PAYMENT_INFO.extraCharge).toFixed(2);
  const totalAmount = paymentAmount.toFixed(2);

  // Resolve creator information once
  const resolvedCreator = creatorInfo
    ? {
      username: creatorInfo.username || 'creator',
      profilePicture: creatorInfo.profile_picture || DEFAULT_USER_AVATAR,
      displayName:
        creatorInfo.displayName || creatorInfo.username || 'Creator'
    }
    : {
      username: getFormValue('c_creator_username') || 'creator',
      profilePicture:
        getFormValue('c_creator_profile_picture') || DEFAULT_USER_AVATAR,
      displayName: getFormValue('c_creator_username') || 'creator'
    };

  return (
    <div id="subscription-summary" className="subscription-summary">
      <div className="subscription-header">
        <div className="subscription-creator-info">
          <img
            src={resolvedCreator.profilePicture}
            alt="Creator Avatar"
            className="subscription-creator-avatar"
          />
          <div className="subscription-creator-details">
            <p>@{resolvedCreator.username}</p>
            <p>{paymentType}</p>
          </div>
        </div>
        <div className="subscription-price">
          <p>
            {totalAmount > 0 ?
              `$${formatAmountWithTwoDecimalPlaces(totalAmount)}${isSubscription ? '/mo' : ''}`
              : 'Free'
            }
          </p>
        </div>
      </div>

      <div id="subscription-details" className="subscription-benefits">
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <p className="text-white text-sm font-medium">
              {paymentType}
            </p>
            <p className="text-white text-sm">
              ${netAmount}
            </p>
          </div>

          {vatAsNumber > 0 && vatPercentage > 0 && showDetails && (
            <div className="flex items-center justify-between">
              <p className="text-neutral-400 text-sm">
                VAT fee ({vatPercentage}%)
              </p>
              <p className="text-neutral-400 text-sm">
                ${formatAmountWithTwoDecimalPlaces(vatAsNumber)}
              </p>
            </div>
          )}

          <div className="flex items-center justify-between">
            <p className="text-neutral-400 text-sm">
              Service fee
            </p>
            <p className="text-neutral-400 text-sm">
              ${formatAmountWithTwoDecimalPlaces(PAYMENT_INFO.extraCharge)}
            </p>
          </div>

          <div className="border-t border-neutral-600 pt-3">
            <div className="flex items-center justify-between">
              <p className="text-white text-base font-bold">Total</p>
              <p className="text-white text-base font-bold">
                ${totalAmount}
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default CheckoutSummaryCard;